import styled from 'styled-components';

export const Container = styled.div`
  .file-input__label {
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 10px;

    width: 100%;
    max-width: 300px;
    min-height: 60px;

    padding: 0 15px;

    background-color: #2f8fdc;

    transition: all 0.5s ease-in-out;
    cursor: pointer;

    border-radius: 30px;
    &:hover {
      filter: brightness(1.1);
    }
  }

  .file-input__icon {
    width: 45px;
    height: 45px;

    background: no-repeat center;
    background-size: contain;
    background-image: ${({ background }: { background?: string }) =>
      background && `url(${background})`};
  }

  .file-input__text {
    max-width: 90%;
    overflow: hidden;

    color: #fff;
    font-size: 1rem;
    text-align: center;
  }

  input {
    display: none;
  }

  @media (max-width: 368px) {
    .file-input__label {
      justify-content: center !important;
    }

    .file-input__icon {
      display: none;
    }
  }
`;
